/**
 * Collection grid size toggle (large / medium / small)
 * - Sets data-grid-size on #main-collection-product-grid; main-collection.css
 *   maps it to the number of columns per breakpoint
 * - The grid element itself is never replaced by AJAX filtering/infinite scroll,
 *   so the chosen size survives those
 * - The choice is remembered per browser (falls back to medium)
 */
(function () {
  const STORAGE_KEY = 'collection-grid-size';
  const SIZES = ['large', 'medium', 'small'];

  const grid = document.getElementById('main-collection-product-grid');
  if (!grid) return;

  const syncButtons = () => {
    const current = grid.dataset.gridSize || 'medium';
    document.querySelectorAll('.collection-grid-toggle__button').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.gridSize === current));
    });
  };

  // Delegated: the toolbar can be re-rendered (e.g. empty-state recovery)
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.collection-grid-toggle__button');
    if (!button || !SIZES.includes(button.dataset.gridSize)) return;

    grid.dataset.gridSize = button.dataset.gridSize;
    try {
      localStorage.setItem(STORAGE_KEY, button.dataset.gridSize);
    } catch (err) {}
    syncButtons();
  });

  syncButtons();
})();
